import {
  radioSchema,
  radioUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { apportionmentInformationText } from '../../definitions/constants';
import {
  FIELDS,
  PARENT,
  YES_NO,
  buildReasonPageDescriptionSchema,
  buildReasonPageDescriptionUI,
  noPriorAnswerYes,
} from './helpers';

const DESCRIPTION_FIELD = 'view:veteranMissingDescription';

export default {
  path: 'veteran-is-missing',
  title: apportionmentInformationText.veteranMissingPageTitle,
  depends: formData =>
    noPriorAnswerYes(formData, [
      FIELDS.veteranIncarceratedOver60Days,
      FIELDS.survivingBeneficiaryIncarceratedOver60Days,
      FIELDS.veteranIncompetentInCare,
      FIELDS.veteranReceivingPensionInCare,
      FIELDS.beneficiaryInEnemyTerritory,
    ]),
  uiSchema: {
    ...titleUI(apportionmentInformationText.veteranMissingPageTitle),
    ...buildReasonPageDescriptionUI(
      DESCRIPTION_FIELD,
      apportionmentInformationText.reasonPageSubDescription,
    ),
    [PARENT]: {
      [FIELDS.veteranDisappeared]: radioUI({
        title: apportionmentInformationText.veteranDisappearedTitle,
        labels: apportionmentInformationText.yesNoLabels,
        errorMessages: {
          required: apportionmentInformationText.veteranDisappearedError,
        },
      }),
    },
  },
  schema: {
    type: 'object',
    properties: {
      ...buildReasonPageDescriptionSchema(DESCRIPTION_FIELD),
      [PARENT]: {
        type: 'object',
        properties: {
          [FIELDS.veteranDisappeared]: radioSchema(YES_NO),
        },
        required: [FIELDS.veteranDisappeared],
      },
    },
  },
};
